// アイテムIDは旧コンポーネント互換のため数値で保持
export type POKEMON_ITEM_ID = number;

// UIで扱うシンプルなアイテム型（表示/選択用途）
export interface ItemOption {
  id: POKEMON_ITEM_ID;
  name: string; // 日本語表示名
}

// アイテム辞書で利用する完全な型
export interface PokemonItem extends ItemOption {
  showInOffence: boolean;
  showInDefence: boolean;
}

// レガシーサポート用の個別アイテムID定数（攻撃側/共通）
export const POKEMON_ITEM_ID_NO_SET: POKEMON_ITEM_ID = 775670783;
export const OFFENCE_ITEM_ID_KODAWARIHATIMAKI: POKEMON_ITEM_ID = 197;
export const OFFENCE_ITEM_ID_KODAWARIMEGANE: POKEMON_ITEM_ID = 274;
export const OFFENCE_ITEM_ID_INOTINOTAMA: POKEMON_ITEM_ID = 247;
export const OFFENCE_ITEM_ID_TIKARANOHACHIMAKI: POKEMON_ITEM_ID = 243;
export const OFFENCE_ITEM_ID_MONOSHIRIMEGANE: POKEMON_ITEM_ID = 244;
export const OFFENCE_ITEM_ID_PUNCHGLOVE: POKEMON_ITEM_ID = 1700;
export const OFFENCE_ITEM_ID_NORMAL_JEWEL: POKEMON_ITEM_ID = 669;
export const OFFENCE_ITEM_ID_KODAWARISUKAFU: POKEMON_ITEM_ID = 264;
export const OFFENCE_ITEM_ID_RUSTED_SWORD: POKEMON_ITEM_ID = 1161;
export const OFFENCE_ITEM_ID_RUSTED_SHIELD: POKEMON_ITEM_ID = 1162;
export const OFFENCE_ITEM_ID_DENKIDAMA: POKEMON_ITEM_ID = 213;
export const OFFENCE_ITEM_ID_FUTOIHONE: POKEMON_ITEM_ID = 235;
export const OFFENCE_ITEM_ID_FLAME_PLATE: POKEMON_ITEM_ID = 275;
export const OFFENCE_ITEM_ID_SPLASH_PLATE: POKEMON_ITEM_ID = 276;
export const OFFENCE_ITEM_ID_ZAP_PLATE: POKEMON_ITEM_ID = 277;
export const OFFENCE_ITEM_ID_MEADOW_PLATE: POKEMON_ITEM_ID = 278;
export const OFFENCE_ITEM_ID_ICICLE_PLATE: POKEMON_ITEM_ID = 279;
export const OFFENCE_ITEM_ID_FIST_PLATE: POKEMON_ITEM_ID = 280;
export const OFFENCE_ITEM_ID_TOXIC_PLATE: POKEMON_ITEM_ID = 281;
export const OFFENCE_ITEM_ID_EARTH_PLATE: POKEMON_ITEM_ID = 282;
export const OFFENCE_ITEM_ID_SKY_PLATE: POKEMON_ITEM_ID = 283;
export const OFFENCE_ITEM_ID_MIND_PLATE: POKEMON_ITEM_ID = 284;
export const OFFENCE_ITEM_ID_INSECT_PLATE: POKEMON_ITEM_ID = 285;
export const OFFENCE_ITEM_ID_STONE_PLATE: POKEMON_ITEM_ID = 286;
export const OFFENCE_ITEM_ID_SPOOKY_PLATE: POKEMON_ITEM_ID = 287;
export const OFFENCE_ITEM_ID_DRACO_PLATE: POKEMON_ITEM_ID = 288;
export const OFFENCE_ITEM_ID_DREAD_PLATE: POKEMON_ITEM_ID = 289;
export const OFFENCE_ITEM_ID_IRON_PLATE: POKEMON_ITEM_ID = 290;
export const OFFENCE_ITEM_ID_PIXIE_PLATE: POKEMON_ITEM_ID = 684;
export const OFFENCE_ITEM_ID_AQUA_CASSETTE: POKEMON_ITEM_ID = 563;
export const OFFENCE_ITEM_ID_INAZUMA_CASSETTE: POKEMON_ITEM_ID = 564;
export const OFFENCE_ITEM_ID_BLAZE_CASSETTE: POKEMON_ITEM_ID = 565;
export const OFFENCE_ITEM_ID_FREEZE_CASSETTE: POKEMON_ITEM_ID = 566;
export const OFFENCE_ITEM_ID_SHIRATAMA: POKEMON_ITEM_ID = 113;
export const OFFENCE_ITEM_ID_KONGOUDAMA: POKEMON_ITEM_ID = 112;
export const OFFENCE_ITEM_ID_HAKKINDAMA: POKEMON_ITEM_ID = 442;
export const OFFENCE_ITEM_ID_BENIIRO_NO_TAMA: POKEMON_ITEM_ID = 467;
export const OFFENCE_ITEM_ID_AIIRO_NO_TAMA: POKEMON_ITEM_ID = 468;
export const OFFENCE_ITEM_ID_KOKORONOSHIZUKU: POKEMON_ITEM_ID = 202;
export const OFFENCE_ITEM_ID_TATSUJIN_OBI: POKEMON_ITEM_ID = 245;
export const OFFENCE_ITEM_ID_BALLOON: POKEMON_ITEM_ID = 584;
export const OFFENCE_ITEM_ID_DAIKONGOUDAMA: POKEMON_ITEM_ID = 1659;
export const OFFENCE_ITEM_ID_DAISHIRATAMA: POKEMON_ITEM_ID = 1660;
export const OFFENCE_ITEM_ID_DAIHAKKINDAMA: POKEMON_ITEM_ID = 1661;
export const OFFENCE_ITEM_ID_IDONOMEN: POKEMON_ITEM_ID = 2106;
export const OFFENCE_ITEM_ID_KAMADONOMEN: POKEMON_ITEM_ID = 2107;
export const OFFENCE_ITEM_ID_ISHIZUENOMEN: POKEMON_ITEM_ID = 2108;

export const DEFENCE_ITEM_ID_NO_SET: POKEMON_ITEM_ID = 775670783;
export const DEFENCE_ITEM_ID_ASSAULT_VEST: POKEMON_ITEM_ID = 683;
export const DEFENCE_ITEM_ID_SINKANOKISEKI: POKEMON_ITEM_ID = 581;
export const DEFENCE_ITEM_ID_HANGENKINOMI: POKEMON_ITEM_ID = 3;
export const DEFENCE_ITEM_ID_RUSTED_SWORD: POKEMON_ITEM_ID = 1161;
export const DEFENCE_ITEM_ID_RUSTED_SHIELD: POKEMON_ITEM_ID = 1162;
export const DEFENCE_ITEM_ID_DAIKONGOUDAMA: POKEMON_ITEM_ID = 1659;
export const DEFENCE_ITEM_ID_DAISHIRATAMA: POKEMON_ITEM_ID = 1660;
export const DEFENCE_ITEM_ID_DAIHAKKINDAMA: POKEMON_ITEM_ID = 1661;
export const DEFENCE_ITEM_ID_BENIIRO_NO_TAMA: POKEMON_ITEM_ID = 467;
export const DEFENCE_ITEM_ID_AIIRO_NO_TAMA: POKEMON_ITEM_ID = 468;
export const DEFENCE_ITEM_ID_IDONOMEN: POKEMON_ITEM_ID = 2106;
export const DEFENCE_ITEM_ID_KAMADONOMEN: POKEMON_ITEM_ID = 2107;
export const DEFENCE_ITEM_ID_ISHIZUENOMEN: POKEMON_ITEM_ID = 2108;
export const DEFENCE_ITEM_ID_BALLOON: POKEMON_ITEM_ID = 584;
